import { render, staticRenderFns } from "./addDormRoom.vue?vue&type=template&id=e51c2d72&"
import script from "./addDormRoom.vue?vue&type=script&lang=js&"
export * from "./addDormRoom.vue?vue&type=script&lang=js&"
import style0 from "./addDormRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports